import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CxpStaffMember } from '../../../../models';

@Component({
  selector: 'cxp-task-staff-sidebar',
  templateUrl: './task-staff-sidebar.component.html',
  styleUrls: ['./task-staff-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskStaffSidebarComponent {
  readonly staff = input<CxpStaffMember[]>([]);
}
